import { createFileRoute } from "@tanstack/react-router";
import { ContinuousPaymentConfirmation } from "@/features/billing/continuous-payment-confirmation/ContinuousPaymentConfirmation";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_dashboard/continuous-payment-confirmation/")({
  component: ContinuousPaymentConfirmationPage,
});

function ContinuousPaymentConfirmationPage() {
  usePageTitle("継続課金支払確認");

  return <ContinuousPaymentConfirmation />;
}

